export default [
  {
    path: "/",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "inicio",
        path: "",
        component: () => import("./pages/Home"),
        meta: {
          title: "Início",
        },
      },
      {
        name: "Error",
        path: "error",
        component: () => import("./pages/Error"),
      },
    ],
  },
];
